import AccountContext from 'context/AccountContext';
import { useContext } from 'react';
import { UnifiedPermit } from 'types/generatedSchemaTypes';
import {
  getAccessPermitPoolingGroupForParkingZone,
  isPermitForParkingZone,
} from 'utils/permitUtils';

const useGetPoolingInfo = (parkingZoneUid: string | undefined) => {
  const {
    loading,
    customer: { permits },
  } = useContext(AccountContext);
  const matchingPermit: UnifiedPermit | undefined = !parkingZoneUid
    ? undefined
    : permits
        ?.filter(
          (permit) =>
            permit.permitType === 'ACCESS' &&
            isPermitForParkingZone(parkingZoneUid, permit)
        )
        .find(Boolean);

  const poolingGroup = getAccessPermitPoolingGroupForParkingZone(
    parkingZoneUid,
    matchingPermit
  );
  const { insidePool, outsidePool } = poolingGroup ?? {};

  const poolinfoExists = Boolean(insidePool && outsidePool);

  return {
    loading: loading,
    matchingPermit,
    poolingGroup,
    userPays:
      poolinfoExists &&
      insidePool === 'USER_PAYS' &&
      outsidePool === 'USER_PAYS',
    userMightHaveToPay:
      poolinfoExists &&
      (insidePool === 'USER_PAYS' || outsidePool === 'USER_PAYS'),
    companyPays:
      poolinfoExists &&
      insidePool !== 'USER_PAYS' &&
      outsidePool !== 'USER_PAYS',
  };
};

export default useGetPoolingInfo;
